<template>
    <div style="min-height: 60vh;" class="card d-flex">
        <simplebar class="card-body" style="max-height: 60vh">
            <ul ref="menuRef" id="metismenu" class="mm-collapse metismenu">
                <li v-for="module_group in menu_data" :key="'module1'+module_group.id" :id="'module1'+module_group.id"  class="has-arrow">
                    <a @contextmenu.prevent="moduleRightClick($event, module_group.id)" >
                        {{module_group.name}}
                    </a>
                    <ul>
                        <li v-show="menuRef != null" v-for="sop_group in module_group.groups" :key="'lvl1'+sop_group.id" :id="'lvl1'+sop_group.id"  class="has-arrow">
                            <a @click="clickLevel(sop_group)" @contextmenu.prevent="groupRightClick($event, sop_group.id)">
                                {{sop_group.name}}
                            </a>
                            <ul class="mm-collapse" style="font-size: 0.6rem;">
                                <li v-for="sop in sop_group.sops" :key="sop.id" class="ps-2" @click="viewDoc(sop.id)">
                                    <a >
                                        {{ sop.name }}
                                    </a>
                                </li>
                                <li v-show="sop_group.sops.length == 0 && !is_loading" class="has-arrow">
                                    No Documents
                                </li>
                                <li v-show="sop_group.sops.length == 0 && is_loading" class="has-arrow">
                                    Loading Documents
                                </li>
                            </ul>
                        </li>
                        <li v-show="menuRef != null && module_group.groups.length == 0" class="has-arrow">
                            No Groups
                        </li>
                    </ul>
                </li>
                
                
            </ul>
        </simplebar>
        
        <div style="border-top: 1px solid grey;" class="p-2 d-flex">
            <!-- <b-button @click="newGroup('parent', null)" variant="outline-primary" class="ms-auto me-auto">
                <i class="fas fa-plus"></i>
                New Parent
            </b-button> -->
            <b-button v-if="is_ccb_admin || is_client_admin" @click="createNewModule()" variant="outline-primary" class="ms-auto me-auto">
                <i class="fas fa-plus"></i>
                Module
            </b-button>
        </div>

        <!--
        //* Extra Components
        -->
        <div style="z-index: 99; position: relative;" @blur="hidePopper" tabindex="-1" @click="hidePopper" ref="contextTreePopper" id="treePopper" v-show="showGroupPopper">
            <ContextMenu :item_id="right_click_item_id" @action="actionHandler" @close="hidePopper"/>
        </div>
        <div style="z-index: 99; position: relative;" @blur="hidePopper" tabindex="-1" @click="hidePopper" ref="contextTreePopper" id="treeModulePopper" v-show="showModulePopper">
            <ModuleContextMenu :item_id="right_click_item_id" @action="moduleActionHandler" @close="hidePopper"/>
        </div>
        
        <b-overlay :show="is_saving_level">
        <b-modal v-if="show_modal" hide-footer id="groupModal" title="Group">
                <b-row>
                    <b-col cols="12" class="mb-3">
                        <label for="1">
                            Name:
                        </label>
                        <b-form-input v-model="modal_data.name"></b-form-input>
                        <div class="text-danger">{{ validation_errors.name }}</div>
                    </b-col>
                    <b-col cols="12">
                        <label for="1">
                            Prefix:
                        </label>
                        <b-form-input v-model="modal_data.prefix"></b-form-input>
                        <div class="text-danger">{{ validation_errors.name }}</div>
                    </b-col>
                </b-row>
                <div class="w-100 mt-3 mb-2" >
                    <b-button style="float: right;" variant="success" @click="save">Save</b-button>
                    <b-button class="me-2" style="float: right;" @click="$bvModal.hide('groupModal')">Cancel</b-button>
                </div>
        </b-modal>
        </b-overlay>
    </div>
</template>

<script>
import MetisMenu from "metismenujs/dist/metismenujs";
import simplebar from "simplebar-vue";
import { createPopper } from '@popperjs/core';
import { sopMethods, sopState, layoutComputed } from '@/state/helpers.js'
import _ from 'lodash';
//import MenuItem from '@/components/widgets/misc/collapse-menu.vue'
import ContextMenu from './tree-context-menu.vue'
import ModuleContextMenu from './tree-module-context-menu.vue'
export default {
    data:() => ({
        is_loading: false,
        rightClickMenu: null,
        right_click_item_id: null,

        showGroupPopper: false,
        showModulePopper: false,

        tree_data:[],
        expanded: true,
        depth: 1,
        menuRef: null,

        isnew_group:false,
        show_modal: false,
        is_saving_level: false,
        modal_data:{
            id: -1,
            parent_id: null,
            name: '',
            prefix:'',
        },
        validation_errors: {
            name: '',
            prefix: ''
        },
    }),
    components:{
        //MenuItem,
        ContextMenu,
        ModuleContextMenu,
        //eslint-disable-next-line
        simplebar
    },
    computed:{
        ...layoutComputed,
        ...sopState,
        is_ccb_admin(){
            return this.$store.getters['clientAdmin/userType'] == 'admin';
        },
        is_client_admin(){
            return this.$store.getters['clientAdmin/userType'] == 'client_admin';
        },
        isLevelSelected(){
            //* Style the current selected level menu node
            var style = '';
            //if(this.returnLevels.length > 0 && this.selected_level != null){
                //if(this.returnLevels[0].id == this.selected_level.id){
                    style = 'text-decoration: underline !important; font-weight: bold;'
                //}
            //}
            return style;
        },
        menu_data(){
            var data = _.cloneDeep(this.modules);
            data.forEach( element => {
                //TODO - Show list of documents for selected level
                // if(this.selected_level != null){
                //     if(this.selected_level.id == element.id){
                //         element['selected'] = true;
                //     }
                // }
                element['parent'] = element.parent_id;
                element['text'] = element.name;
                element['is_folder'] = true;
            })
            
            data.forEach(ele => {
                let parent_id = ele.parent_id;
                if (parent_id == null) {
                //* Parent item -- do nothing
                }
                else {
                    //* If element is a child element, push to children array.
                    data.forEach(d => {
                        if (d.id === parent_id) {
                            let childArray = d.nodes;
                            if (!childArray) {
                                childArray = []
                            }
                            childArray.push(ele);
                            d.nodes = childArray;
                        }
                    })
                }
            });
            //* Remove duplicate elements
            data = data.filter(ele => ele.parent_id == null);
            if(data.length > 0){
                //*Set parent root as expanded;
                data[0]['opened'] = true;
            }
            return data;
        },
        tree_levels(){
            let data = [];
            if(this.sop_groups != null){
                data = this.sop_groups;
            }
            return data;
        },
        loaded_sops(){
            let data = [];
            if(this.sops != null){
                data = _.cloneDeep(this.sops.sop_types);
            }
            return data;
        }
    },
    methods:{
        ...sopMethods,
        getLi(){
            return document.getElementById('metismenu2');
        },
        debugModules(){
            window.axios.get("api/ccbdocadmin/sopmodules");
        },
        viewDoc(doc_id){
            // this.$router.push({
            //     name: 'document_view',
            //     params: {
            //         'document_id' : id,
            //     }
            // });
            if(this.$store.getters['clientAdmin/userType'] == 'client'){
                //* only clients can view
                this.$router.push({
                    name: 'document_view',
                    params: {
                        'document_id' : doc_id,
                    }
                });

            }
            else{
                //* client_admin and ccb_admin can go to the edit screen
                this.$router.push({
                    name: 'document_edit',
                    params: {
                        'document_id' : doc_id,
                    }
                });
            }
        },
        fileDoubleClick(id){
            this.$eventHub.$emit('openDocument', id);
        },
        showAddDialog(){
            //* tell documentList component to show add sop dialog
            this.$eventHub.$emit('addNewSop');
        },
        processLevels(levels){
            var data = _.cloneDeep(levels);
            data.forEach( element => {
                //TODO - Show list of documents for selected level
                if(this.selected_level != null){
                    if(this.selected_level.id == element.id){
                        element['selected'] = true;
                    }
                }
                element['parent'] = element.parent_id;
                element['text'] = element.name;
                element['is_folder'] = true;
            })
            
            data.forEach(ele => {
                let parent_id = ele.parent_id;
                if (parent_id == null) {
                //* Parent item -- do nothing
                }
                else {
                    //* If element is a child element, push to children array.
                    data.forEach(d => {
                        if (d.id === parent_id) {
                            let childArray = d.nodes;
                            if (!childArray) {
                                childArray = []
                            }
                            childArray.push(ele);
                            d.nodes = childArray;
                        }
                    })
                }
            });
            //* Remove duplicate elements
            data = data.filter(ele => ele.parent_id == null);
            if(data.length > 0){
                //*Set parent root as expanded;
                data[0]['opened'] = true;
            }

            return data;
        },
        clickLevel(payload, force){
            if(this.selected_sop_group != payload.id || force){
                this.is_loading = true;
                this.selectSopGroup(payload.id)
                .then(()=>{
                    this.loadSops(this.selected_sop_group)
                    .then(()=>{
                        this.is_loading = false;
                    })
                })
            }
        },
        editModule: async function (id) {
            let el = this;
            let found_module = this.menu_data.find( item => {
                return item.id == id;
            })
            if(found_module){
                console.log('Found', found_module)
                try {
                    const { value: inputValue } = await this.$swal.fire({
                    title: 'Module Name:',
                    input: 'text',
                    inputValue: found_module.name,
                    inputPlaceholder: 'Enter a module title',
                    showCancelButton: true,
                    inputValidator: (value) => {
                        if (!value) {
                        return 'You need to enter a title!';
                        }
                    }
                    });

                    // Check if the user clicked on "Save" (not "Cancel") and the input is valid
                    if (inputValue) {
                    //this.saveData(inputValue);
                        let payload = {
                            id: id,
                            name: inputValue,
                        }
                        el.saveModule(payload)
                        .then(()=>{
                            el.loadModules();
                        })
                        .catch(()=>{
                            el.$swal.fire({
                                icon: 'error',
                                title: 'Failed to save module',
                                text: 'Please try again or contact support.',
                            });
                        });
                    }
                } catch (error) {
                    console.error('Error displaying SweetAlert:', error);
                }
            }
            
        },
        createNewModule: async function () {
            let el = this;
            try {
                const { value: inputValue } = await this.$swal.fire({
                title: 'Module Name:',
                input: 'text',
                inputPlaceholder: 'Enter a module title',
                showCancelButton: true,
                inputValidator: (value) => {
                    if (!value) {
                    return 'You need to enter a title!';
                    }
                }
                });

                // Check if the user clicked on "Save" (not "Cancel") and the input is valid
                if (inputValue) {
                    el.is_saving_level = true;
                //this.saveData(inputValue);
                    let payload = {
                        id: -1,
                        name: inputValue,
                    }
                    el.saveModule(payload)
                    .then(()=>{
                        el.loadModules()
                        .then(()=>{
                            el.is_saving_level = false;
                        })
                    })
                    .catch(()=>{
                        el.is_saving_level = false;
                        el.$swal.fire({
                            icon: 'error',
                            title: 'Failed to create module',
                            text: 'Please try again or contact support.',
                        });
                    });
                }
            } catch (error) {
                console.error('Error displaying SweetAlert:', error);
            }
        },

        newFromModuleGroup(module_id){
            this.modal_data.name = '';
            this.modal_data.prefix = '';
            this.modal_data.client_sop_module_id = module_id;
            this.modal_data.sop_module_id = module_id;
            this.showModal();
        },


        newGroup(type, id){ //* id == the id of the right clicked element
            if(type === 'parent'){
                //* find element to get the parent_id
                let item = _.find(this.sop_groups, {id:id});
                if(item != undefined){
                    this.modal_data.parent_id = item.parent_id;
                }
            }
            else{
                this.modal_data.parent_id = id;
            }

            this.modal_data.name = '';
            this.modal_data.prefix = '';
            this.modal_data.client_sop_module_id = id;
            this.modal_data.sop_module_id = id;
            
            this.showModal();
        },
        editGroup(id){
            //let group = _.find(this.sop_groups, {id: id});
            let group = null;

            this.menu_data.forEach( (module)=>{
                module.groups.forEach( (sub_group)=> {
                    if(sub_group.id == id){
                        group = sub_group
                    }
                })
            })
            console.log('GROUP', group)
            if(group != undefined){
                this.modal_data.id = group.id;
                this.modal_data.name = group.name;
                this.modal_data.prefix = group.code;
                this.modal_data.client_sop_module_id = group.client_sop_module_id;
                this.modal_data.sop_module_id = group.sop_module_id;
            }
            this.showModal();
        },
        save(){
            this.validation_errors = {
                name: this.modal_data.name ? '' : 'Name is required.',
                prefix: this.modal_data.prefix ? '' : 'Prefix is required.'
            };
        
            if (this.validation_errors.name) {
                return; // Don't proceed if there are validation errors
            }

            this.is_saving_level = true;
            this.saveSopGroup(this.modal_data)
            .then(()=>{
                this.loadModules()
                .then(()=>{
                    this.is_saving_level = false;
                    this.$bvModal.hide('groupModal');
                })
                //const force_reload = true;
                //this.clickLevel({id:this.modal_data.client_sop_module_id}, force_reload);
                // this.loadSopGroups()
                // .then(()=>{
                //     this.is_saving_level = false;
                //     this.tree_data = this.processLevels(this.tree_levels);
                //     console.log(this.tree_data);
                //     this.$bvModal.hide('groupModal');
                // })
                // .catch(()=>{ this.is_saving_level = false; })
            }).catch(()=>{
                this.is_saving_level = false;
                this.$swal.fire({
                    icon: 'error',
                    title: 'Failed to save group',
                    text: 'Please try again or contact support.',
                });
            })
        },

        showModal(){
            this.show_modal = true;
            this.$nextTick(()=>{
                this.$bvModal.show('groupModal');
                this.$root.$once('bv::modal::hidden',(event)=>{
                    if(event.type == 'hidden' && event.componentId == 'groupModal'){
                        this.show_modal = false;
                        //* Clear form inputs
                        this.modal_data.name = '';
                        this.modal_data.prefix = '';
                        this.modal_data.client_sop_module_id = ""
                        this.modal_data.sop_module_id = ""
                    }
                })
            })
        },
        //* popper stuff */
        moduleRightClick(event, id){
            if(this.is_ccb_admin == false && this.is_client_admin == false){
                return;
            }

            const item = document.getElementById(`module1${id}`);
            //this.$nextTick(()=>{
            
            
            if (item.classList.contains("mm-active")) {
                // If it has the class, remove it
                item.classList.remove("mm-active");
                item.children[1].classList.remove('mm-show');
            }
            //*set id to be used while saving
            this.right_click_item_id = id;
            this.$nextTick(()=>{
                this.showModulePopper = true;
                this.$nextTick(()=>{
                    //* Get ref to item element and popper elem
                    const element = document.querySelector('#module1'+id)
                    const popper = document.querySelector('#treeModulePopper')
                    console.log('Event', event);
                    console.log('E',element);
                    console.log('P', popper);
                    this.$nextTick(()=>{
                        this.rightClickMenu = createPopper(element, popper,{
                            placement: 'top'
                        });
                        setTimeout(()=>{
                            //* Set focus to the popper element to make sure the blur even is fired
                            if(this.$refs.contextTreePopper != undefined){
                                this.$refs.contextTreePopper.focus();
                            }
                        }, 250);
                    });
                })
            })
        //})
        },
        groupRightClick(event, id){
            if(this.is_ccb_admin == false && this.is_client_admin == false){
                return;
            }
            //*set id to be used while saving
            this.right_click_item_id = id;

            this.hidePopper();

            this.$nextTick(()=>{
                this.showGroupPopper = true;
                this.$nextTick(()=>{
                    //* Get ref to item element and popper elem
                    const element = document.querySelector('#lvl1'+id)
                    const popper = document.querySelector('#treePopper')
                    console.log('Event', event);
                    console.log('E',element);
                    console.log('P', popper);
                    this.$nextTick(()=>{
                        this.rightClickMenu = createPopper(element, popper,{
                            placement: 'bottom'
                        });
                        setTimeout(()=>{
                            //* Set focus to the popper element to make sure the blur even is fired
                            if(this.$refs.contextTreePopper != undefined){
                                this.$refs.contextTreePopper.focus();
                            }
                        }, 250);
                    });
                })
            })
        },
        hidePopper(){
            /*if(this.rightClickMenu != null){
                this.rightClickMenu.destroy();
            }*/
            this.showGroupPopper = false;
            this.showModulePopper = false;
        },
        moduleActionHandler(type){
            switch(type){
                case 'add_parent':{
                    //trigger add new module
                    this.createNewModule()
                    break;
                }
                case 'add_child':{
                    //trigger add new SOP group
                    this.newFromModuleGroup(this.right_click_item_id);
                    break;
                }
                case 'edit':{
                    //trigger edit module
                    this.editModule(this.right_click_item_id)
                    break;
                }
                case 'delete':{
                    //trigger delete module
                    let params = { id: this.right_click_item_id };
                    this.deleteModule(params)
                    .then( ()=>{
                        this.loadModules()
                        .then(()=>{
                            this.is_saving_level = false;
                        })
                    });
                    break;
                }
            }
        },
        actionHandler(type){
            if(type === 'add_child'){
                this.newGroup('child', this.right_click_item_id);
            }
            else if(type === 'add_parent'){
                this.newGroup('parent', this.right_click_item_id);
            }
            else if(type === 'edit'){
                this.editGroup(this.right_click_item_id);
            }
            else if(type === 'delete'){
                let params = { id: this.right_click_item_id };
                this.deleteSopGroup(params)
                .then(()=>{
                    this.loadSopGroups()
                    .then(()=>{
                        this.tree_data = this.processLevels(this.tree_levels);
                        //this.$bvModal.hide('groupsModal');
                    })
                })
            }
        },
        isActiveItem(id){
            if(this.selected_sop_group == id){
                return 'mm-active'
            }
            else{
                return '';
            }
        },
        dupe(){

        },
        initMetisMenu(){
            //if(document.getElementById('metismenu')){
                this.menuRef = new MetisMenu("#metismenu", {toggle:true});
                console.log('MENU', this.menuRef)
            //}
        },
    },
    mounted(){
        if(this.modules.length == 0){
            //this.loadSopGroups()
            this.loadModules()
            .then(()=>{
                setTimeout(()=>{
                    this.initMetisMenu();
                },600)
            })
        }
        else{
            setTimeout(()=>{
                this.initMetisMenu();
            },600 )
        }
        this.$eventHub.$on('clickedLevelItem', this.clickLevel);
    },
    beforeDestroy(){
        if(this.menuRef != null){
            this.menuRef.dispose();
        }
        this.$eventHub.$off('clickedLevelItem');
        //this.$eventHub.$off('setMenuItemData');
    }
}
</script>

<style scoped>
.metismenu {
  padding-left: 0;
  font-size: 0.75rem;
}
.metismenu, .metismenu ul {
  list-style: none;
}
.metismenu li {
  position: relative;
}
.metismenu li a {
  display: block;
  padding-top: 5px;
  padding-bottom: 5px;
  color: #333;
  text-decoration: none;
  outline: 0 none;
}
.metismenu ul:before {
  position: absolute;
  border-left: 1px dotted #333;
  content: "";
  width: 30px;
  top: 25px;
  left: 5px;
  bottom: 17px;
}
.metismenu ul > li:before {
  position: absolute;
  border-top: 1px dotted #333;
  content: "";
  width: 30px;
  top: 13px;
  left: -26px;
}
li.active > a > span.fa-folder-o:before {
  content: "\f115" !important;
}

.metismenu ul > li:before {
    width: 15px; /* Your new width value */
}










</style>